module.exports = "/lucky-balls/img/weager/balls/color/brown.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/color/brown.png
// module id = 1178
// module chunks = 0